<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="变动时间">
        <DatePicker
          :value="timeRange"
          :editable="false"
          format="yyyy-MM-dd"
          type="daterange"
          @on-change="selectTime"
          placeholder="开始时间 - 结束时间"
          style="width:200px"
        ></DatePicker>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/integral/logsDetail"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
      >
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntegralRecord",
  data() {
    return {
      user_id:'',
      column: [
        {
          title: "积分事件",
          key: "remark",
          align: "center"
        },
        {
          title: "积分值",
          key: "change_price",
          align: "center",
          width: 200
        },
        {
          title: "变动时间",
          key: "created_at",
          align: "center",
          width: 200
        }
      ],
      searchCondition: {
        start_time: "",
        end_time: ""
      },
      timeRange: ["", ""],
    };
  },
  methods: {
    // 格式化时间
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.timeRange = ["", ""];
      }
      this.searchCondition.start_time = this.timeRange[0];
      this.searchCondition.end_time = this.timeRange[1];
      this.$refs.grid.searchRefresh();
    },
    selectTime(e) {
      this.timeRange = e;
    }
  },
  created() {
    this.searchCondition.user_id = this.$route.query.user_id;
  }
};
</script>
<style lang="scss" scoped>
.ivu-checkbox-wrapper {
  margin-right: 50px;
}
</style>
